<template>
  <div id="contents">
    <div id="header">
      <section class="hero is-primary is-medium is-bold">
        <div class="hero-body">
          <div class="container">
            <h1 class="title is-1 is-spaced">Dummy Text Generator</h1>
            <h2 class="subtitle">コピペですぐ使えるダミーテキストを生成します</h2>
          </div>
          <p class="blank5em"></p>
          <div class="has-text-centered">
            <gen-text
              quote-textname="Lorem"
              v-bind:output-number=300
              v-bind:gen-options="['needBreak']"
              button-msg="すぐにテキストを生成する"
              button-icon="run-fast"
            ></gen-text>
          </div>
        </div>
      </section>
    </div>
    <div id="main">
      <section>
        <p class="blank2em"></p>
        <div class="has-text-centered">
          <h2 class="title is-4">詳細な条件を指定する</h2>
          <p class="blank2em"></p>
        </div>
        <!-- <div id="app"> -->
        <textGenUI msg="hoge fuga piyo" />
        <!-- </div> -->
      </section>
    </div>
    <div id="footer">
      <footer class="footer">
        <div class="content has-text-centered is-size-7">
            <p>管理者：<a href="https://twitter.com/unknown_strings">ysko</a></p>
            <p>当ページでは<a href="https://www.aozora.gr.jp/">青空文庫</a>および<a href="https://ja.wikipedia.org/">ウィキペディア</a>※よりテキストを引用しています。</p>
            <p>※「超弦理論」（2019年8月15日 (木) 03:31‎ UTCの版）『ウィキペディア日本語版』。<a href="https://ja.wikipedia.org/wiki/%E8%B6%85%E5%BC%A6%E7%90%86%E8%AB%96">引用元URL</a></p>
        </div>
        <div class="content has-text-centered is-size-7 has-text-weight-light">
            <p>当ページを使用することによって、あるいは使用できないことで生じたいかなる損害に対して、運営者およびこのサイトは一切責任を負いません。</p>
            <p>当サイトはアクセス解析サービスとして、「Google Analytics」を利用しています。</p>
            <p>この機能はCookieを無効にすることで収集を拒否できます。お使いのブラウザの設定をご確認ください。この規約に関して、詳しくは<a href="https://www.google.com/analytics/terms/jp.html">こちらのページ</a>をご確認ください。</p>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import textGenUI from "./components/ui.vue";
import genText from "./components/generate.vue";

export default {
  name: "app",
  components: {
    textGenUI,
    genText
  }
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
  margin-top: 60px;
}

.blank1em {
  margin-bottom: 1em;
}

.blank2em {
  margin-bottom: 2em;
}

.blank5em {
  margin-bottom: 5em;
}
</style>
